var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 58.5,
    r: 58.5,
    fill: "#FF060A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9799 47.7733C93.2809 44.3579 88.164 39.1423 83.9964 35.4433L83.7498 35.2707C83.3395 34.9412 82.8769 34.6828 82.3812 34.5062C72.3323 32.632 25.5646 23.8901 24.6522 24.001C24.3966 24.0369 24.1522 24.1295 23.9371 24.2723L23.7028 24.4573C23.4143 24.7502 23.1952 25.1041 23.0617 25.493L23 25.6533V26.5287V26.6643C28.2649 41.3247 49.0533 89.35 53.1468 100.62C53.3934 101.384 53.862 102.839 54.7374 102.913H54.9347C55.4032 102.913 57.4007 100.274 57.4007 100.274C57.4007 100.274 93.1083 56.9714 96.721 52.36C97.1886 51.792 97.6015 51.181 97.954 50.5352C98.044 50.0299 98.0015 49.5099 97.8308 49.0259C97.6601 48.5419 97.367 48.1103 96.9799 47.7733ZM66.5618 52.8162L81.8017 40.178L90.7409 48.4144L66.5618 52.8162ZM60.6434 51.9901L34.4052 30.4866L76.8574 38.3162L60.6434 51.9901ZM63.0108 57.6249L89.8655 53.2971L59.1638 90.287L63.0108 57.6249ZM30.8419 32.632L58.4487 56.059L54.4538 90.3117L30.8419 32.632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.a3187a88769a210e696cb0e8e5cb1299.svg";
export { ForwardRef as ReactComponent };